export default "__VITE_ASSET__2b4260b9__"